import produce from "immer";
import { IStoreState } from "../initialStoreState";

import { LoadState } from "../../constants/enums";
import { MarketingActions } from ".";
import { defaultMarketingsState } from "./marketing.types";
import { FETCH_MARKETINGS_GROUPED_LIST_FAILED, FETCH_MARKETINGS_GROUPED_LIST_PROGRESS, FETCH_MARKETINGS_GROUPED_LIST_SUCCESS, FETCH_MARKETINGS_HISTORY_LIST_FAILED, FETCH_MARKETINGS_HISTORY_LIST_PROGRESS, FETCH_MARKETINGS_HISTORY_LIST_SUCCESS, FETCH_MARKETING_STATUS_COUNT_FAILED, FETCH_MARKETING_STATUS_COUNT_PROGRESS, FETCH_MARKETING_STATUS_COUNT_SUCCESS } from "./marketingActions";

export const MarketingsReducer = (
  state: IStoreState["Marketings"] = defaultMarketingsState,
  action: MarketingActions
) => {
  switch (action.type) {
    case FETCH_MARKETINGS_HISTORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketHistoryListLoading = LoadState.InProgress;
        draftState.marketingHistoryList = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_MARKETINGS_HISTORY_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketHistoryListLoading = LoadState.Loaded;
        draftState.marketingHistoryList = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_MARKETINGS_HISTORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketHistoryListLoading = LoadState.Failed;
        draftState.marketingHistoryList = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_MARKETINGS_GROUPED_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketingGroupedListLoading = LoadState.InProgress;
        draftState.marketingGroupedList = [];
      });
      return newState;
    }
    case FETCH_MARKETINGS_GROUPED_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketingGroupedListLoading = LoadState.Loaded;
        draftState.marketingGroupedList = list;
      });
      return newState;
    }
    case FETCH_MARKETINGS_GROUPED_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketingGroupedListLoading = LoadState.Failed;
        draftState.marketingGroupedList = [];
      });
      return newState;
    }
    case FETCH_MARKETING_STATUS_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.marketingStatusCountLoading = LoadState.InProgress;
        draftState.marketingStatusCount = [];
      });
      return newState;
    }
    case FETCH_MARKETING_STATUS_COUNT_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.marketingStatusCountLoading = LoadState.Loaded;
        draftState.marketingStatusCount = list;
      });
      return newState;
    }
    case FETCH_MARKETING_STATUS_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.marketingStatusCountLoading = LoadState.Failed;
        draftState.marketingStatusCount = [];
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};
